import * as home from './home';
import * as product from './product';
import * as media from './media';
import * as brand from './brand';
import * as about from './about';
import * as qr from './qr';

export default {
  home,
  product,
  media,
  brand,
  about,
  qr
}; 